/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Vdot_RangeInputs */

const en_exp_vdot_range = /** @type {(inputs: Exp_Vdot_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner: 25–35. Recreational: 35–45. Competitive: 45–55. Elite: 55–70+. World class: 75–85.`)
};

const de_exp_vdot_range = /** @type {(inputs: Exp_Vdot_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger: 25–35. Freizeitläufer: 35–45. Wettkampf: 45–55. Elite: 55–70+. Weltklasse: 75–85.`)
};

/**
* | output |
* | --- |
* | "Beginner: 25–35. Recreational: 35–45. Competitive: 45–55. Elite: 55–70+. World class: 75–85." |
*
* @param {Exp_Vdot_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_vdot_range = /** @type {((inputs?: Exp_Vdot_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Vdot_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_vdot_range(inputs)
	return de_exp_vdot_range(inputs)
});